"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.1875 40.2708C31.7834 40.2706 31.3951 40.1137 31.1041 39.8333L16.6666 26.125C16.5154 25.9792 16.3951 25.8045 16.313 25.6112C16.2308 25.4179 16.1885 25.21 16.1885 25C16.1885 24.7899 16.2308 24.5821 16.313 24.3888C16.3951 24.1955 16.5154 24.0207 16.6666 23.875L31.0416 10.1666C31.1948 10.0162 31.3762 9.89735 31.5753 9.81696C31.7745 9.73657 31.9875 9.69619 32.2022 9.69813C32.4169 9.70006 32.6292 9.74427 32.8268 9.82823C33.0245 9.9122 33.2037 10.0343 33.3541 10.1875C33.5046 10.3407 33.6234 10.522 33.7038 10.7212C33.7842 10.9203 33.8246 11.1333 33.8227 11.348C33.8207 11.5628 33.7765 11.775 33.6925 11.9727C33.6086 12.1703 33.4865 12.3495 33.3333 12.5L20.0833 25L33.3333 37.5C33.6259 37.7929 33.7903 38.1901 33.7903 38.6041C33.7903 39.0182 33.6259 39.4153 33.3333 39.7083C33.1902 39.8746 33.0149 40.0101 32.8179 40.1068C32.621 40.2035 32.4065 40.2593 32.1875 40.2708Z",
    fill: fill
  }));
};

exports["default"] = _default;